import { Store } from '@reduxjs/toolkit';

import { injectDataConnectionsConfiguration, ServerConnection } from '@paragon/data-connections';

import { setLogOutReason } from './logOutReason';
import { LoginDataSliceState } from './store/logInDataSlice';

const LOOP_PREVENTION_KEY = 'PREVENT_LOGIN_LOOP';

export function initializeDataConnections(reduxStore: Store<LoginDataSliceState>) {
  ServerConnection.applyGlobalMiddleware((requestPromise) =>
    requestPromise.catch((error) => {
      if (error.statusCode === 401 && reduxStore.getState().logInData.loggedInUser != null) {
        setLogOutReason('Session expired. Please log in again.');

        if (window.sessionStorage.getItem(LOOP_PREVENTION_KEY) == null) {
          window.sessionStorage.setItem(LOOP_PREVENTION_KEY, 'yes please');
          window.location.reload();
        } else {
          window.sessionStorage.removeItem(LOOP_PREVENTION_KEY);
        }
      }

      throw error;
    }),
  );

  injectDataConnectionsConfiguration(
    () => reduxStore.getState().environment.urls,
    () => {
      const { logInData } = reduxStore.getState();
      return logInData.loggedInUser?.token ?? null;
    },
  );
}
